import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { AxiosWrapper } from 'services/AxiosWrapper';
import { ItineraryManagerApiService } from 'services/ItineraryManagerApi';
import { ItineraryTypes } from './types';

export const useItinerarySaveAndPublishQueries = (
  itineraryManagerApi: ItineraryManagerApiService<AxiosWrapper<AxiosInstance>>,
  bookingUuid: string,
  version: string
) => {
  const queryClient = useQueryClient();
  return {
    saveItinerary: useMutation({
      mutationFn: async (data: ItineraryTypes['ItineraryData']) => {
        if (!bookingUuid || !version) {
          return;
        }
        return itineraryManagerApi.saveItinerary(bookingUuid, version, data);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['getItineraryView', bookingUuid, version] });
      },
    }),
    publishItinerary: useMutation({
      mutationFn: async () => {
        if (!bookingUuid || !version) {
          return;
        }
        return itineraryManagerApi.publishItinerary(bookingUuid, version);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['getItineraryView', bookingUuid, version] });
      },
    }),
  };
};
